// extracted by mini-css-extract-plugin
module.exports = {"block":"Block_block__BIG-c"};